<template>
	<div>
    <base-header type="gradient-danger" class="pb-6 pb-8 pt-5 pt-md-8">
		</base-header>
		<div class="container-fluid mt--9" style="max-width: 2000px;">
			<div class="d-flex mb-3 mb-xl-0 flex-column flex-xl-row">
        <div class="mr-3 flex-grow-1" style="min-width: 1px;">
          <!-- Datos del cliente -->
          <div class="card shadow mb-3">
            <div v-if="customer">
              <div class="card-header bg-transparent">
                <div class="d-flex justify-content-between align-items-center">
                  <div class="flex-grow-1">
                    <div class="d-flex align-items-center">
                      <h3 class="m-0">{{invoice.CardName}}</h3>
                      <h4 class="text-muted m-0 pl-1">{{invoice.CardCode}}</h4>
                    </div>
                    <h4 class="text-muted m-0 d-flex align-items-center font-weight-normal">
                      <span>Factura 
                        <span style="letter-spacing: 0.5px;">
                          #{{$route.params.DocNum}}
                        </span>
                      </span>
                      <badge v-if="invoice.DocumentStatus === 'bost_Open'" type="primary" class="ml-2">Abierta</badge>
                      <badge v-else-if="invoice.CancelStatus === 'csYes'" type="danger" class="ml-2">Cancelada</badge>
                      <badge v-else-if="invoice.DocumentStatus === 'bost_Close'" type="light" class="ml-2">Cerrada</badge>
                    </h4>
                  </div>
                  <div class="d-flex flex-wrap flex-xl-row ml-xl-4 align-items-start justify-content-center">
                    <base-button
                      v-if="invoice"
                      @click="invoiceXML();"
                      icon="fas fa-file-code"
                      size="sm"
                      class="mb-2"
                      :disabled="!invoice || downloadingXml">
                      XML
                    </base-button>
                    <base-button 
                      @click="invoicePdf();" 
                      icon="fas fa-file-pdf"
                      size="sm"
                      :disabled="!invoice || downloadingInvoice">
                      PDF
                    </base-button>
                  </div>
                </div>
              </div>
              <div class="card-body">
                <div class="d-flex flex-column flex-xl-row">
                  <div class="d-flex my-1">
                    <h5 class="m-0">RFC</h5>
                    <p class="text-xs pl-2 m-0"><b>{{invoice.FederalTaxID}}</b></p>
                  </div>
                  <div class="d-flex my-1 ml-xl-4" v-if="customer.U_TS_RegFiscal && regimenes">
                    <h5 class="m-0">Régimen Fiscal</h5>
                    <p class="text-xs pl-2 m-0"><b>{{regimenes.find(x => x.Code === customer.U_TS_RegFiscal).Name}}</b></p>
                  </div>	
                  <div class="d-flex my-1 ml-xl-4">
                    <h5 class="m-0">Uso CFDI</h5>
                    <p class="text-xs pl-2 m-0"><b>{{ invoice.U_TS_UsoCFDI40 }}</b></p>
                  </div>
                </div>
              </div>
              </div>
              <div v-else style="height: 700px; padding-top: 300px;">
                <base-loader></base-loader>
              </div>
          </div>
          <!-- Detalles de factura -->
          <div class="card shadow mb-3" v-if="customer">
            <div class="card-header">
              <h6 class="heading-small text-muted m-0 p-0">Detalles de Factura</h6>
            </div>
            <div class="card-body">
              <div class="container m-0 p-0">
              <div class="row">
                <div class="col-md-6 col-xl-4 d-flex my-1">
                  <h5 class="m-0">Almacén</h5>
                  <p class="text-xs pl-2 m-0"><b>{{invoice.DocumentLines[0].WarehouseCode}}</b></p>
                </div>
                <div class="col-md-6 col-xl-4 d-flex my-1">
                  <h5 class="m-0">C. P. de Almacén</h5>
                  <p class="text-xs pl-2 m-0"><b>{{zipCode}}</b></p>
                </div>
                <div class="col-md-6 col-xl-4 d-flex my-1" v-if="invoice.SalesPersonCode && salesPersonOptions">
                  <h5 class="m-0">Vendedor</h5>
                  <p class="text-xs pl-2 m-0"><b>{{salesPersonOptions.find(x => x.SalesEmployeeCode === invoice.SalesPersonCode).SalesEmployeeName}}</b></p>
                </div>				
                <div class="col-md-6 col-xl-4 d-flex my-1" >
                  <h5 class="m-0">Contacto</h5>
                  <p class="text-xs pl-2 m-0 text-truncate" v-if="invoice.ContactPersonCode && customer">
                    <b>{{customer.ContactEmployees.find(x => x.InternalCode === invoice.ContactPersonCode).Name}}</b></p>
                </div>
                <div class="col-md-6 col-xl-4 d-flex my-1">
                  <h5 class="m-0">Moneda</h5>
                  <p class="text-xs pl-2 m-0"><b>{{invoice.DocCurrency}}</b></p>
                </div>
                <div class="col-md-6 col-xl-4 d-flex my-1">
                  <h5 class="m-0">Fecha contable</h5>
                  <p class="text-xs pl-2 m-0"><b>{{invoice.DocDate}}</b></p>
                </div>
                <div class="col-md-6 col-xl-4 d-flex my-1">
                  <h5 class="m-0">Fecha de entrega</h5>
                  <p class="text-xs pl-2 m-0"><b>{{invoice.DocDueDate}}</b></p>
                </div>
                <div class="col-md-6 col-xl-4 d-flex my-1" v-if="globalInformation">
                  <h5 class="m-0">Periodicidad</h5>
                  <p class="text-xs pl-2 m-0"><b>{{globalInformation.periodicity}}</b></p>
                </div>
                <div class="col-md-6 col-xl-4 d-flex my-1" v-if="globalInformation">
                  <h5 class="m-0">Meses</h5>
                  <p class="text-xs pl-2 m-0"><b>{{globalInformation.months}}</b></p>
                </div>
                <div class="col-md-6 col-xl-4 d-flex my-1" v-if="globalInformation">
                  <h5 class="m-0">Año</h5>
                  <p class="text-xs pl-2 m-0"><b>{{globalInformation.year}}</b></p>
                </div>
              </div>
            </div>
            </div>
          </div>
          <!-- Tabla de artículos -->
          <div class="card shadow mb-3" v-if="customer">
            <div class="card-header border-0">
              <h6 class="heading-small text-muted m-0 p-0">Artículos</h6>
            </div>
              <div v-if="invoice" class="table-responsive">
                <base-table thead-classes="thead-light" :data="invoice.DocumentLines">
                <template #columns>
                  <th width="5%">#</th>
                  <th width="35%" class="pl-5">Artículo</th>
                  <th width="10%" class="text-right">Cantidad</th>
                  <th width="10%" >U. medida</th>
                  <th width="10%" class="text-right">Precio por unidad</th>
                  <th width="10%" class="text-right">Total</th>
                </template>
                <template #default="{ row }">
                  <td scope="row" width="5%">
                    {{ row.LineNum + 1 }}
                  </td>
                  <td scope="row" width="35%" class="pl-5">
                    <b> {{ row.ItemCode }} </b>
                    {{ row.ItemDescription }}
                    <br>
                    <b class="text-primary">{{ row.U_SubCode }} </b>
                    <span class="text-primary">{{ row.U_SubDescription }}</span>
                  </td>
                  <td scope="row" width="10%" class="text-right">
                    {{ row.Quantity }}
                  </td>
                  <td scope="row" width="10%">
                    {{ row.MeasureUnit}}
                  </td>
                  <td scope="row" width="10%" class="text-right">
                    {{ currencyFormat(row.UnitPrice, currency.iso) }}
                  </td>
                  <td scope="row"  width="10%" class="text-right">
                    {{ currencyFormat(currency.iso === 'MXN' ? row.RowTotalSC : row.RowTotalFC, currency.iso) }}
                  </td>
                </template>
                </base-table>
              </div>
              <div class="d-flex justify-content-end px-4 border-top py-2">
                <table class="text-right text-sm">
                  <tr>
                    <th class="pr-4"><h5 class="my-1">Subtotal</h5></th>
                    <td>
                      {{ currencyFormat(currency.iso === 'MXN' ? invoice.DocTotalSys - invoice.VatSumSys : invoice.DocTotalFc - invoice.VatSumFc, currency.iso) }}
                    </td>
                  </tr>
                  <tr>
                    <th class="pr-4"><h5 class="my-1">IVA</h5></th>
                    <td>
                      {{ currencyFormat(currency.iso === 'MXN' ? invoice.VatSumSys : invoice.VatSumFc, currency.iso) }}
                    </td>
                  </tr>
                  <tr>
                    <th class="pr-4"><h5 class="my-1">Total</h5></th>
                    <td>
                      {{ currencyFormat(currency.iso === 'MXN' ? invoice.DocTotalSys : invoice.DocTotalFc, currency.iso) }}
                    </td>
                  </tr>
                </table>
              </div>
          </div>
          <!-- Datos Adicionales -->
          <div class="card shadow mb-3" v-if="customer">
            <div class="card-header">
              <h6 class="heading-small text-muted m-0 p-0">Datos adicionales</h6>
            </div>
            <div class="card-body">
              <div class="container m-0 p-0">
                <div class="row">
                <div class="col-6 col-lg-6 d-flex my-1">
                  <h5 class="m-0">Referencia</h5>
                  <p class="text-xs ml-2"><b>{{invoice.NumAtCard}}</b></p>
                </div>
                <div class="col-6 col-lg-6 d-flex my-1">
                  <h5>Comentarios</h5>
                  <p class="text-xs ml-2"><b>{{invoice.Comments}}</b></p>
                </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="custom-side-cards">
          <!-- Facturar a -->
          <div class="card shadow mb-3">
            <div v-if="customer">
              <div class="card-header py-3">
                <h6 class="heading-small text-muted m-0">Facturar a:</h6>
              </div>
              <div class="card-body py-2">
                <div class="d-flex mb-1 ">
                  <i class="fas fa-map-marker-alt mr-2 pt-1 text-gray"></i>
                  <div class="text-xs m-0 font-weight-bold text-default">
                    <span>{{invoice.AddressExtension.BillToStreet}} </span>
                    <span>{{invoice.AddressExtension.BillToStreetNo}} </span>
                    <span>{{invoice.AddressExtension.BillToBlock}}</span>
                    <br>
                    <span>{{invoice.AddressExtension.BillToZipCode}} </span>
                    <span>{{invoice.AddressExtension.BillToCity}} </span>
                    <span>{{invoice.AddressExtension.BillToState}}</span>
                    <br>
                    <span>{{invoice.AddressExtension.BillToCountry}}</span>
                  </div>
                </div>
                <hr class="my-2">
                <div class="d-flex align-items-center mb-1">
                  <h5 class="m-0">Vía de Pago</h5>
                  <span class="text-xs m-0 ml-2">
                    {{invoice.PaymentMethod}}
                  </span>
                </div>
                <div class="d-flex align-items-center mb-1">
                  <h5 class="m-0">Método de Pago</h5>
                  <span class="text-xs m-0 ml-2">
                    {{paymentMethod}}
                  </span>
                </div>
                <div class="d-flex align-items-center mb-1">
                  <h5 class="m-0">Condiciones de Pago</h5>
                  <span v-if="paymentGroup" class="text-xs m-0 ml-2">
                    {{paymentGroup.PaymentTermsGroupName}}
                  </span>
                </div>
              </div>
            </div>
            <div v-else class="py-6">
              <base-loader></base-loader>
            </div>
          </div>
          <!-- Enviar a -->
          <div class="card shadow mb-3" v-if="customer">
            <div class="card-header">
              <h6 class="heading-small text-muted m-0 p-0">Enviar a:</h6>
            </div>
            <div class="card-body py-2">
              <div class="d-flex mb-1">
                <i class="fas fa-map-marker-alt mr-2 pt-1 text-gray"></i>
                <div class="text-xs m-0 font-weight-bold text-default">
                  <span>{{invoice.AddressExtension.ShipToStreet}} </span>
                  <span>{{invoice.AddressExtension.ShipToStreetNo}} </span>
                  <span>{{invoice.AddressExtension.ShipToBlock}}</span>
                  <br>
                  <span>{{invoice.AddressExtension.ShipToZipCode}} </span>
                  <span>{{invoice.AddressExtension.ShipToCity}} </span>
                  <span>{{invoice.AddressExtension.ShipToState}}</span>
                  <br>
                  <span>{{invoice.AddressExtension.ShipToCountry}}</span>
                </div>
              </div>
              <hr class="my-2">
              <div class="d-flex align-items-center mb-1">
                <h5 class="m-0">Método de envío</h5>
                <span v-if="shippingMethod" class="text-xs m-0 ml-2">
                  {{shippingMethod.Description}}
                </span>
              </div>
              <div class="d-flex align-items-center mb-1">
                <h5 class="m-0">Pago flete</h5>
                <span v-if="freightPayment" class="text-xs m-0 ml-2">
                  {{freightPayment.Description}}
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
		</div>
  </div>
</template>

<script>
import axios from 'axios'
import BaseLoader from '@/components/BaseLoader.vue';
import moment from "moment";
import { getAuth } from "firebase/auth";
import currency from '@/data/currency.json'
import Formats from "@/mixins/Formats";

  export default {
    mixins: [Formats],
    components:{
      BaseLoader,
    },
    data() {
      return {
        HANA_URL: process.env.VUE_APP_HANA_URL,
        user: null,
        invoice: null,
        docLines:[],
        customer: null,
        globalInformation: null,
        zipCode: null,
        paymentMethod: null,
        paymentGroup: null,
        needsAuthorization: false,
        authorizationKey: null,
        inputAuthKey: null,
        needsReference: false,
        importFileNum: null,
        modals:{
          complete: false,
        },
        loadingImportFileNum: false,
        balanceFavorOptions: null,
        insufficientBalanceText: null, 
        regimenes: null,
        salesPersonOptions: null,
        downloadingInvoice: false,
        downloadingXml: false,
        currency: null,
        shippingMethod: null,
        freightPayment: null,
      }
    },

    methods: {
      invoicePdf(){
        this.downloadingInvoice = true;
        const json = {
          "DocCode": "DPI20015",
          "Pairs": {
            "DocKey@": this.invoice.DocEntry
          }
        };
        axios.post(`/api/pdf_file`,json)
        .then(res => {
          if(res.data.se_err){
            this.$swal("Error", res.data.se_err.message, "error");
          } else {
            let link = document.createElement('a');
            link.download = `Factura_anticipo_${this.invoice.DocNum}.pdf`;
            link.href =  res.data.base64;
            link.click();
          }
        }).catch(error => {
          console.error(error); 
        }).finally(() => {
          this.downloadingInvoice = false;
        });
      },
      invoiceXML(){
        if(this.invoice.U_WebXML){
          let link_xml = document.createElement('a');
          link_xml.download = `Factura_anticipo_${this.invoice.DocNum}.xml`;
          link_xml.href = this.invoice.U_WebXML;
          link_xml.target = '_blank';
          document.body.appendChild(link_xml);
          link_xml.click();
          document.body.removeChild(link_xml);
        } else if (this.invoice.U_TS_ReportID){
          const [año, mes, dia] = this.invoice.DocDate.split("-");
          const download = `https://canplast.net:50000/api/v1/sap/xml/${año}/${mes}/${dia}/${this.invoice.CardCode}/${this.invoice.CardName}/${this.invoice.U_TS_ReportID}?token=${localStorage.getItem('token-cpm')}`
          window.open(download, '_blank');
        } else {
          this.downloadingXml = true;
          fetch(`https://canplast.net:50000/api/v1/sap/GET/Invoice/UUID/${this.invoice.DocNum}`, {
						method: 'GET',
						headers: {
							'Accept': 'application/json',
							'Content-Type': 'application/json',
							'x-access-token': localStorage.getItem('token-cpm')
						}
					})
					.then((response) => response.json())
					.then((responseJson) => {
            if(responseJson.UUID){
              const [año, mes, dia] = this.invoice.DocDate.split("-");
              const download = `https://canplast.net:50000/api/v1/sap/xml/${año}/${mes}/${dia}/${this.invoice.CardCode}/${this.invoice.CardName}/${responseJson.UUID}?token=${localStorage.getItem('token-cpm')}`
              window.open(download, '_blank');
            } else {
              this.$swal("Error", "No se pudo obtener el XML", "error");
            }
          })
          .catch((error) => {
            console.error(error);
          }).finally(() => {
            this.downloadingXml = false;
          });
        }
      },
      formatDate(date){
        return moment(date).format('YYYY-MM-DD');
      },
    },
    created(){
      this.user = getAuth().currentUser;

      axios.get(`api/invoices/downpayment?DocNum=${this.$route.params.DocNum}`)
      .then(res => {
        this.invoice = res.data.value[0];
        console.log("FACTURA DE ANTICIPO", this.invoice)

        this.currency = currency.find(x => x.key === this.invoice.DocCurrency);

        this.paymentMethod = this.invoice.PaymentMethod === '99' ? 'PPD' : 'PUE';

        axios.get(`/api/paymentsByCode?code=${this.invoice.PaymentGroupCode}`)
        .then(res => {
          this.paymentGroup = res.data.value.find(x => x.GroupNumber === this.invoice.PaymentGroupCode);
        }).catch(err => {
          console.error(err); 
        });
        
        axios.get(`api/warehouses/${this.invoice.DocumentLines[0].WarehouseCode}`)
        .then(res => {
          this.zipCode = res.data.value[0].ZipCode
        }).catch(err => {
          console.error(err); 
        });

        axios.get(`/api/business_partners?card_code=${this.invoice.CardCode}`)
        .then(res => {
          this.customer = res.data;
          console.log("CUSTOMER", this.customer)
        }).catch(err => {
          console.error(err); 
        });

        axios.get(`api/user_fields/ShippingMethod`)
        .then(res => {
          this.shippingMethod = res.data.value[0].ValidValuesMD.find(x => x.Value === this.invoice.U_ShippingMethod);
        }).catch(err => {
          console.error(err); 
        });

        axios.get(`api/user_fields/FreightPayment`)
        .then(res => {
          this.freightPayment = res.data.value[0].ValidValuesMD.find(x => x.Value === this.invoice.U_FreightPayment);
        }).catch(err => {
          console.error(err); 
        });

      }).catch(err => {
        console.error(err); 
      });


      axios.get(`/api/regimen_fiscal`)
      .then(res => { 
        this.regimenes = res.data;
      }).catch(err => {
        console.error(err); 
      });

      axios.get(`/api/sales_persons`)
      .then((response) => {
        this.salesPersonOptions = response.data.value;
      }).catch((error) => {
        console.error(error);
      });

    }
    
  }
</script>

<style scoped>
.custom-side-cards{
  min-width: 100%; 
  width: 100%;
}
@media (min-width:1200px) { 
  .custom-side-cards {
    min-width: 360px; 
    width: 360px;  
  }
}
</style>